import React from 'react'
import { connect } from 'react-redux'
import { getFieldsByType, FormattedAddress, getControlIsRenderable } from 'utilities'

class AddressSelector extends React.Component {
	render() {
		const { addresses, children } = this.props
		// console.log(addresses)
		return (
			<div className="address-selector ">
				{children}
				{
					addresses.length > 0 ? addresses.map((address, i) => (
						<AddressButton
							isFirst={i === 0}
							label={address.label}
							value={address.value}
							showCounty={address.showCounty}
							showCountry={address.showCountry}
							onSelect={this.props.onSelect}
							key={address.fieldId}
						/>
					))
					:
					<div style={{padding: 15}}>None available.</div>
				}
			</div>
		)
	}
}
export default connect((state, props) => ({
	addresses: props.addresses
		? props.addresses
		: getFieldsByType(['addressBlock', 'registeredAgentSearch'], state.wizard.wizard.fields)
			.reduce((addresses, address) => {
				if(address.type === 'registeredAgentSearch'){
					return [
						...addresses,
						{
							...address,
							fieldId: address.fieldId + '_PRIMARY',
							label: address.label + ' (Physical)',
							value: {
								ADDR1: address.value.ADDR1,
								ADDR2: address.value.ADDR2,
								ADDR3: address.value.ADDR3,
								CITY: address.value.CITY,
								STATE: address.value.STATE,
								COUNTY: address.value.COUNTY,
								POSTAL_CODE: address.value.POSTAL_CODE,
								COUNTRY: address.value.COUNTRY
							}
						},
						{
							...address,
							fieldId: address.fieldId + '_MAIL',
							label: address.label + ' (Mailing)',
							value: {
								ADDR1: address.value.MAIL_ADDR.ADDR1,
								ADDR2: address.value.MAIL_ADDR.ADDR2,
								ADDR3: address.value.MAIL_ADDR.ADDR3,
								CITY: address.value.MAIL_ADDR.CITY,
								STATE: address.value.MAIL_ADDR.STATE,
								COUNTY: address.value.MAIL_ADDR.COUNTY,
								POSTAL_CODE: address.value.MAIL_ADDR.POSTAL_CODE,
								COUNTRY: address.value.MAIL_ADDR.COUNTRY
							}
						}
					]
				}else{
					return [...addresses, address]
				}
			}, [])
			.filter(
				address => address.parent.type !== 'REPEATER' &&
										address.fieldId !== props.fieldId &&
										address.value.ADDR1 !== '' &&
										address.value.ADDR1 !== null &&
										address.active === true
			)
			.filter(address => getControlIsRenderable(address, state.wizard.wizard.fields))
}))(AddressSelector)


class AddressButton extends React.Component {
	select = () => {
		this.props.onSelect(this.props.value)
	}
	render() {
		const { label, value, showCounty, showCountry } = this.props
		return (
			<button type='button' className="address-button" onClick={this.select}>
				<span className="label">{label}</span>
				<FormattedAddress
					value={value}
					showCounty={showCounty}
					showCountry={showCountry}
					className="address"
				/>
			</button>
		)
	}
}
